import React from 'react';

function Footer(props) {
    return (
        <footer className="footer-wrp">
        {/* Container */}
        <div className="container">
          {/* Row */}
          <div className="row footer-row">
            {/* Footer Logo */}
            <div className="col-md-5">
              <a href="#" className="footer-logo navbar-brand"><img style={{height:'56px',width:'100%'}} src="/assets/img/logo.jpg" alt="" /> </a>
            </div>
            {/* End Logo */}
            {/* Footer Right Content */}
            <div className="col-md-7 footer-content-wrp">
              {/* Footer Content */}
              <div className="footer-content">
                <h5>Website</h5>
                <ul>
                  <li><a href="#">Store</a></li>
                  <li><a href="#">Minting</a></li>
                  <li><a href="#">Profile</a></li>
                  <li><a href="#">User Gallery</a></li>
                </ul>
              </div>
              {/* End Content */}
              {/* Footer Content */}
              <div className="footer-content">
                <h5>Contact</h5>
                <ul>
                  <li><a href="#">Facebook</a></li>
                  <li><a href="#">Instagram</a></li>
                  <li><a href="#">Twitter</a></li>
                  <li><a href="#">Discord</a></li>
                </ul>
              </div>
              {/* End Content */}
              {/* Footer Content */}
              <div className="footer-content">
                <h5>Join Us</h5>
                <ul>
                  <li><a href="#">Log In</a></li>
                  <li><a href="#">Sign Up</a></li>
                </ul>
              </div>
              {/* Footer Content */}
              <div className="footer-content">
                <h5>Legal</h5>
                <ul>
                  <li><a href="#">Terms of Service</a></li>
                  <li><a href="#">Privacy Policy</a></li>
                </ul>
              </div>
              {/* End Content */}
            </div>
            {/* End right Content */}
          </div>
          {/* End Row */}
          {/* Footer bottom */}
          <div className="footer-bottom text-center">
            <p>© 2021 Foxchange. All Rights Reserved</p>
          </div>
          {/* End Bottom */}
        </div>
        {/* End Container */}
      </footer>
    );
}

export default Footer;
